(function() { window.GUID_c593f8af_6c69_4928_9d11_ffb58ea04539 = { getGuid: function() { return "c593f8af-6c69-4928-9d11-ffb58ea04539"; } }; })();
//namespace CS.Controls {
//    export module PersonaPicture {
//        //const will be render in JS, type is used for reference(Ts only)
//        export const PersonaType = CS.Enumeration.PersonaType;
//        export type PersonaType = CS.Enumeration.PersonaType;
//        export const PictureSize = CS.Enumeration.PictureSize;
//        export type PictureSize = CS.Enumeration.PictureSize;
//        export function SetupImageClasses(image: JQuery, personaType: PersonaType, pictureSize: PictureSize) {
//            var div = image.closest(".persona-picture");
//            if (div.length == 0) {
//                //No div wrapper. So we create it and move the image inside it
//                div = $('<div></div>');
//                var inner = $('<div></div>');
//                inner.addClass('inner');
//                div.append(inner);
//                div.insertAfter(image);
//                image.appendTo(inner);
//            }
//            else
//                div.removeAttr('class');
//            div.addClass("persona-picture");
//            switch (personaType) {
//                case PersonaType.Player:
//                    div.addClass("player");
//                    break;
//                case PersonaType.Team:
//                    div.addClass("team");
//                    break;
//                case PersonaType.User:
//                    div.addClass("user");
//                    break;
//                default:
//            }
//            switch (pictureSize) {
//                case PictureSize.Large:
//                    div.addClass("large");
//                    break;
//                case PictureSize.Medium:
//                    div.addClass("medium");
//                    break;
//                case PersonaPicture.PictureSize.Small:
//                    div.addClass("small");
//                    break;
//            }
//        }
//    }
//}

//# sourceMappingURL=PersonaHelper.js.map
